import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'
import { BlackWeekendInfoWrapper } from './styles'
import { darkMode } from 'styles/theme'
import { BLACK_WEEKEND_REGULATIONS_LINK } from 'constants/links'
import BlackWeekendUnlimitedDiscountsModal from 'components/shared/Promotions/components/BlackWeekendUnlimitedDiscountsModal'
import { useState } from 'react'

const BlackWeekendInfo = () => {
    const [isOpened, setIsOpened] = useState(false)
    const PromoCodeInfo = (
        <Text variant="bodySmall" color="grayscale_400">
            <FormattedMessage
                id="promo.black_weekend.creator_promo_code_info"
                defaultMessage="<span>Skorzystaj ze zniżki nawet do 50%</span> z kodem <span>BLACKWEEKEND</span>! Zniżka naliczy się po wprowadzeniu kodu rabatowego w podsumowaniu zakupu."
                description="Keep the html tags in the translation"
                values={{
                    span: (chunks: string[]) => (
                        <>
                            <Text
                                as="span"
                                variant="bodySmall"
                                color="primary_500"
                            >
                                {chunks}
                            </Text>
                        </>
                    ),
                }}
            />
        </Text>
    )
    const PromoDurationInfo = (
        <Text variant="bodySmall" color="grayscale_400">
            <FormattedMessage
                id="promo.black_weekend.creator_promo_duration"
                defaultMessage="<span>Sprawdź wysokość zniżki</span> na wejście do parku w różnych miesiącach. "
                description="Keep the html tags in the translation"
                values={{
                    span: (chunks: string[]) => (
                        <>
                            <Text
                                as="a"
                                isUnderlined
                                onClick={() => setIsOpened(true)}
                                variant="bodySmall"
                                color="primary_500"
                            >
                                {chunks}
                            </Text>
                        </>
                    ),
                }}
            />
        </Text>
    )
    const RegulationsLink = (
        <Text
            as="a"
            href={BLACK_WEEKEND_REGULATIONS_LINK}
            target="_blank"
            variant="bodySmall"
            isUnderlined
            color="grayscale_400"
        >
            <FormattedMessage
                id="promo.black_weekend.regulations_link"
                defaultMessage="Regulamin promocji"
            />
        </Text>
    )

    return (
        <BlackWeekendInfoWrapper isFullWidth>
            <BlackWeekendUnlimitedDiscountsModal
                close={() => setIsOpened(false)}
                isOpened={isOpened}
            />
            <Info color="info" hasNoBackground hasBorder theme={darkMode}>
                {PromoCodeInfo}
                {PromoDurationInfo}
                {RegulationsLink}
            </Info>
        </BlackWeekendInfoWrapper>
    )
}

export default BlackWeekendInfo
